var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-wrap",style:({
    fontFamily:_vm.config.fontFamily?_vm.config.fontFamily:'auto',
  })},[_c('ul',_vm._l((_vm.textRow),function(item,index){return _c('li',{key:index,style:({
        marginLeft: _vm.config.offsetX + 'px',
        marginTop: _vm.config.offsetY + 'px'
      })},[_c('span',{staticClass:"label",style:({
          minWidth: _vm.config.text.minWidth + 'px',
          fontSize: item.tSize + 'px',
          color: item.tColor
        })},[_vm._v(_vm._s(item['label']))]),_c('span',{staticClass:"value",class:[_vm.config.value.isOverflow ? 'valueSpace' : ''],style:({
          fontSize: item.vSize+ 'px',
          color: item.vColor
        })},[_vm._v(_vm._s(_vm.chartData[0][item['value']]))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }